module.exports = __webpack_public_path__ + "static/media/Photo.29d5f5d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Photo.svg
// module id = 1136
// module chunks = 0